import { api } from "@/lib/api";
import { emitFichas } from "@/components/FichasWallet";

export async function payPublication(workshopId) {
  const { data } = await api.post(`/business/publication/${workshopId}/pay`);
  emitFichas();
  return data;
}

export async function checkoutNewWorkshop(payload) {
  const { data } = await api.post("/business/publication/checkout", payload);
  emitFichas();
  return data;
}

export const PUB_RESULT = {
  approved: ["success", "¡Pago aprobado! Tu taller fue creado. Agrega una fecha de sesión para que los alumnos lo vean."],
  rejected: ["error", "El pago fue rechazado. Tu taller está guardado: puedes reintentar el pago."],
  aborted: ["error", "El pago no se completó. Tu taller está guardado: puedes reintentar el pago."],
  timeout: ["error", "El pago expiró. Tu taller está guardado: puedes reintentar el pago."],
  error: ["error", "No pudimos confirmar el pago. Tu taller está guardado: inténtalo nuevamente."],
};
